export default __webpack_public_path__ + "static/08_Appendix_02.pdf";